// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'credit';

export const Component = () => (
  <path d='M23.037 2H1.485c-.431 0-.766.144-1.054.431A1.408 1.408 0 0 0 0 3.485v16.667c0 .43.144.766.431 1.053.288.288.623.432 1.054.432h21.552c.431 0 .766-.144 1.054-.432.287-.287.43-.622.43-1.053V3.485a1.41 1.41 0 0 0-.43-1.054A1.408 1.408 0 0 0 23.037 2Zm.526 8.86v9.292c0 .335-.191.526-.526.526H1.485c-.335 0-.526-.191-.526-.526V10.86h22.605Zm0-3.927v2.92H.958v-2.92h22.605Zm0-3.449v2.443H.958V3.484c0-.335.191-.479.526-.479h21.552c.335 0 .526.144.526.48h.001ZM3.448 17.71c-.335 0-.526-.144-.526-.48 0-.334.191-.478.526-.478h3.928c.335 0 .479.144.479.479 0 .335-.144.479-.48.479H3.449Z' />
);

export const viewBox = '0 0 25 25';
